/** @jsxImportSource @emotion/react */
import * as React from "react";
import { css, SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";
import { isNilOrEmpty } from "../language/module";
import { MediumText } from "../styles/styles";
import { getResource } from "../language/resources/getResource";
import { IAppState } from "../core/redux/IAppState";
import { useSelector } from "react-redux";
import { LiftAccessRuleEventDetail } from "./models";

const Entry = styled("span")`
  ${MediumText};
  color: white;
  padding: 15px 0px;
  text-align: center;
`;

/**
 * ValidationMetadataHistoryTable: a component that renders a metadata history including last modified date and
 * which user modified the data.  If no metadata history is availble, the table is not rendered.
 */
export const ValidationMetadataHistoryTable: React.FC<{
  ruleHistory?: LiftAccessRuleEventDetail[];
  tableCss?: SerializedStyles;
}> = ({ ruleHistory, tableCss }) => {
  const resources = useSelector((state: IAppState) => state.locale);

  return (
    <div
      css={css`
        background-color: black;
        ${tableCss};
        border-radius: 0.5rem;
      `}
    >
      <table
        css={css`
          border-collapse: collapse;
          width: 100%;
        `}
      >
        {!isNilOrEmpty(ruleHistory) && (
          <thead>
            <tr
              css={css`
                border-bottom: 1px solid white;
              `}
            >
              <th
                css={css`
                  text-align: left;
                `}
              >
                <Entry>
                  {getResource(resources, "LIFT_ACCESS_HISTORY_UPDATED")}
                </Entry>
              </th>
              <th
                css={css`
                  text-align: left;
                `}
              >
                <Entry>{getResource(resources, "LIFT_ACCESS_HISTORY_USER")}</Entry>
              </th>
              <th
                css={css`
                  text-align: left;
                `}
              >
                <Entry>
                  {getResource(resources, "LIFT_ACCESS_HISTORY_VALUE")}
                </Entry>
              </th>
            </tr>
          </thead>
        )}
        <tbody>
          {!isNilOrEmpty(ruleHistory) &&
            ruleHistory?.map((item) => (
              <tr key={`${item.eventCategory}-${item.modifiedUtcDateTime}`}>
                <td
                  css={css`
                    min-width: 195px;
                    vertical-align: top !important;
                  `}
                >
                  <Entry id="rule-history-tooltip-updated">
                    {item.modifiedDateFormatted}
                  </Entry>
                </td>
                <td
                  css={css`
                    min-width: 160px;
                    vertical-align: top !important;
                    word-break: break-word;
                  `}
                >
                  <Entry id="rule-history-tooltip-user">
                    {item.modifiedByName ||
                      getResource(resources, "LIFT_ACCESS_HISTORY_UNKNOWN")}
                  </Entry>
                </td>
                <td
                  css={css`
                    min-width: 115px;
                    vertical-align: top !important;
                  `}
                >
                  <Entry id="rule-history-tooltip-previous">
                    {item.valueFormatted}
                  </Entry>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};
